import styled from 'styled-components'
import { Box } from '@astro-ui/components'
import { withPopupConfirmation } from 'components/PopupConfirmation'
import { useLocation } from 'react-router-dom'
import { poolingMap, ticketingAllTickets } from 'config/routes'

import NavBar, { NAVBAR_HEIGHT } from './NavBar'
import Sidebar from './Sidebar'
import PrintArea from './PrintArea'

import './print_area.css'

export type DashboardPropsType = {
  children: JSX.Element
}

const Dashboard = ({ children }: DashboardPropsType) => {
  const location = useLocation()
  return (
    <Container>
      <NavBar className="print-none" />
      <Content className="print-none">
        <Sidebar />
        <Wrapper
          id="dashboard-content"
          as="main"
          p={
            location.pathname === poolingMap || location.pathname === ticketingAllTickets
              ? '0px'
              : {
                  mobile: '24px 16px',
                  desktop: '24px 32px',
                }
          }
        >
          {children}
        </Wrapper>
      </Content>
      <PrintArea />
    </Container>
  )
}

export default withPopupConfirmation(Dashboard)

const Wrapper = styled(Box)`
  flex: 1;
  overflow: auto;
  height: calc((var(--vh, 1vh) * 100) - ${NAVBAR_HEIGHT}px);

  &.stop-scrolling {
    overflow: hidden;
  }
`
const Content = styled.div`
  display: flex;
  margin-top: ${NAVBAR_HEIGHT}px;
`
const Container = styled.section`
  overflow: hidden;
`
